import { render, staticRenderFns } from "./Payement_failed.vue?vue&type=template&id=32692cfa&scoped=true"
import script from "./Payement_failed.vue?vue&type=script&lang=js"
export * from "./Payement_failed.vue?vue&type=script&lang=js"
import style0 from "./Payement_failed.vue?vue&type=style&index=0&id=32692cfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32692cfa",
  null
  
)

export default component.exports